// extracted by mini-css-extract-plugin
module.exports = {"title_div":"Payment_title_div__7R_yK","participationCompetition_div":"Payment_participationCompetition_div__3Yn9G"};